import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import type { AppDispatch, RootState } from "@src/store/store";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";

interface TItemTagsInitialState {
	tagIds: Array<number>;
}

const initialState = false;

export const { thunk: removeTag, slice: removeTagSlice } = getThunkAndSlice<TItemTagsInitialState, typeof initialState>({
	initialState,
	method: "post",
	path: "/api/System/RemoveItemTags",
});

export const removeListingsTagsLocally =
	(removals: Record<number, Array<string>>) => (dispatch: AppDispatch, getState: () => RootState) => {
		const state = getState();
		const withoutRemoved = <T extends EventInventoryRecord>(x: T): T => {
			const removed = removals[x.Listing_ID];
			if (!removed?.length || !x.Tags) return x;
			const remaining = x.Tags.split("|").filter((t) => t && !removed.includes(t));
			return { ...x, Tags: remaining.length ? remaining.join("|") : null };
		};

		const eventId = state.pricing.selection.event?.Event_ID;
		dispatch(pricingActions.updateInventoryAll({ data: state.pricing.eventInventoryAll.data.map(withoutRemoved), eventId }));

		if (state.pricing.globalInventory.data.length) {
			const globalData = state.pricing.globalInventory.data as Array<EventInventoryRecord>;
			dispatch(pricingActions.updateGlobalInventory({ data: globalData.map(withoutRemoved) }));
		}
	};
